import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(LanguageDetector)
	.use(initReactI18next)
	.use(Backend)
	.init({
		debug: true,
		fallbackLng: "en",
		lowerCaseLng: true,
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		detection: {
			order: ["localStorage", "cookie", "navigator"],
			caches: ["localStorage"],
		},
		backend: {
			// Bust the browser cache whenever translation files change.
			// REACT_APP_VERSION is injected from package.json at build time.
			queryStringParams: { v: process.env.REACT_APP_VERSION ?? "dev" },
		},
	});

export default i18n;
